import { IAgentData } from "@/interfaces/IAgentData";
import { cn } from "@/lib/utils";
import clsx from "clsx";
import Image from "next/image";
type IAgentModelProps = Pick<IAgentData, "ai_model" | "image_model_ai"> & {
  imageClassName?: string;
};

export default function AgentModel({
  ai_model = "gpt-4o",
  image_model_ai,
  imageClassName,
}: IAgentModelProps) {
  return (
    <div className={clsx("flex gap-2 justify-start items-center")}>
      <div className="w-6 h-6 rounded-full">
        {image_model_ai && (
          <Image
            src={image_model_ai}
            alt={`${ai_model}-image`}
            className={cn("w-[24px] min-w-[24px] h-[24px]", imageClassName)}
            width={24}
            height={24}
          />
        )}
      </div>
      <p className="text-base-tertiary/40 leading-caption-m tracking-caption-m font-medium capitalize text-xs">
        {ai_model}
      </p>
    </div>
  );
}
